module.exports = __webpack_public_path__ + "img/history-2017.bbed20be.jpg";